<footer>
    <p>© {{ actualYear }} Marsh McLennan, All Rights Reserved.</p>
    <img src="../../../../assets/icons/logo-white.svg" alt="" />
</footer>
